<template>
  <app-panel class="hidden lg:block" title="Pour aller plus loin">
    <template v-if="resource">
      <blog-post-resource-type-chip size="small" :type="resource.type" />
      <p class="font-semibold">
        {{ resource.title }}
      </p>
    </template>
    <template v-else>
      <app-skeleton-text class="mb-1" :height="22" width="30%" />
      <app-skeleton-text width="70%" />
    </template>

    <template #footer>
      <blog-post-resource-cta
        v-if="resource"
        block
        :post="post"
        :resource="resource"
        size="lg"
      />
      <app-button v-else block disabled size="lg" tag="span" />
    </template>
  </app-panel>

  <teleport to="body">
    <app-slide-y-transition appear>
      <app-bottom-sheet v-if="resource" class="lg:hidden">
        <p class="mb-2 font-bold">Pour aller plus loin</p>

        <div class="flex items-center gap-2">
          <app-icon v-if="resourceIcon" :icon="resourceIcon" :size="20" />
          <p class="mr-2 line-clamp-2 flex-auto text-sm">
            {{ resource.title }}
          </p>

          <blog-post-resource-cta :post="post" :resource="resource" />
        </div>
      </app-bottom-sheet>
    </app-slide-y-transition>
  </teleport>
</template>

<script lang="ts" setup>
import { toBlogPostResourceIcon } from "~/business-areas/blog/blog.model";
import BlogPostResourceCta from "~/pages/blog/_includes/components/blog-post-resource-cta.vue";
import type { BlogPostPage } from "~~/model/blog.model";

const properties = defineProps<{
  post: BlogPostPage;
}>();

const { data } = useLazyFetch(
  `/api/blog/posts/${properties.post.id}/resources`,
  {
    server: false,
    default: () => [],
  },
);

const resource = computed(() => data.value[0]);
const resourceIcon = computed(() =>
  toBlogPostResourceIcon(resource.value?.type),
);
</script>
